import { useLayoutEffect } from 'react';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';

type IosStatusBarStyle = NonNullable<NativeStackNavigationOptions['statusBarStyle']>;

/** Applies status bar style via react-native-screens (required on iOS 26+). No-op on Android. */
export function useIosStatusBarStyle(statusBarStyle: IosStatusBarStyle): void {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    if (Platform.OS !== 'ios') {
      return;
    }
    navigation.setOptions({ statusBarStyle });
  }, [navigation, statusBarStyle]);
}
